import React from 'react';
import { styled } from '@compiled/react';
import Avatar from '@atlaskit/avatar';
import { token } from '@atlaskit/tokens';
import Tooltip from '@atlaskit/tooltip';

type Props = {
	value: string;
};

export const AssigneeCell = ({ value }: Props) => {
	if (value === '') {
		return null;
	}

	return (
		<Wrapper>
			<Tooltip content={value} position="bottom-start">
				<Avatar
					size="small"
					testId="project-create-importer-upload-flow.ui.mapping-screen.mapping-table.assignee-cell.avatar"
				/>
				<ContentWrapper>{value}</ContentWrapper>
			</Tooltip>
		</Wrapper>
	);
};

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	overflow: 'hidden',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
	'> div': {
		whiteSpace: 'nowrap',
		overflow: 'hidden',
		textOverflow: 'ellipsis',
		display: 'flex',
		alignItems: 'center',
	},
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ContentWrapper = styled.span({
	marginLeft: token('space.100', '8px'),
});
